export * from '@primeuix/themes/material/autocomplete';
export { default } from '@primeuix/themes/material/autocomplete';
